import React, { Dispatch, useEffect, useState } from "react";

// components
import KeywordSection from "./atoms/KeywordSection";
import SpecialEquipmentSection from "./atoms/SpecialEquipmentSection";
import BondingLevelSection from "./atoms/BondingLevelSection";
import QualityAssuranceSection from "./atoms/QualityAssuranceSection";

// hooks
import { useSaveConfirmation } from "hooks/useSaveConfirmation";

// types
import { SectionsProps } from "pages/BusinessProfileEdit/BusinessProfileEdit";

// styles
import styles from "./ServiceSection.module.scss";

export type ChangesProps = {
  setChangesState: Dispatch<React.SetStateAction<boolean[]>>;
};

export default function ServiceSection({ setUnsavedChanges }: SectionsProps) {

  const KEYWORDS = "Keywords" as const;
  const SPECIAL_EQUIPMENT_MATERIALS = "Special equipment/materials" as const;
  const BONDING_LEVELS = "Bonding levels" as const;
  const QUALITY_ASSURANCE_STANDARDS = "Quality assurance standards" as const;

  const saveConfirmation = useSaveConfirmation<typeof KEYWORDS | typeof SPECIAL_EQUIPMENT_MATERIALS | typeof BONDING_LEVELS | typeof QUALITY_ASSURANCE_STANDARDS>();

  return (
    <div className={styles["service-section-root"]}>
      <h2 className={styles["heading"]}>Service information</h2>

      <KeywordSection setUnsavedChanges={setUnsavedChanges} saveConfirmation={saveConfirmation} section={KEYWORDS} />

      <SpecialEquipmentSection setUnsavedChanges={setUnsavedChanges} saveConfirmation={saveConfirmation} section={SPECIAL_EQUIPMENT_MATERIALS} />

      <BondingLevelSection setUnsavedChanges={setUnsavedChanges} saveConfirmation={saveConfirmation} section={BONDING_LEVELS} />

      <QualityAssuranceSection setUnsavedChanges={setUnsavedChanges} saveConfirmation={saveConfirmation} section={QUALITY_ASSURANCE_STANDARDS} />
    </div>
  );
}
